<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外教开课Checklist</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="老师ID">
              <Input v-model="queryParam.tchId" placeholder="请输入老师ID" clearable></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="姓名">
              <Input v-model="queryParam.keyword" placeholder="支持模糊搜索" clearable></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item>
              <Button type="primary" :loading="searchLoading" icon="search" @click="search">查询</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="table-container">
      <Table :columns="columns" :data="tableData" :loading="tableLoading" border stripe></Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right;">
          <Page
            :total="pagination.totalCount"
            :current="pagination.pageIndex"
            :page-size="pagination.pageSize"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            show-sizer
            show-elevator
            show-total>
          </Page>
        </div>
      </div>
    </div>

    <Modal v-model="detailVisible" title="外教开课Checklist" width="960" footer-hide>
      <div v-if="detailLoading" style="text-align: center; padding: 30px 0">
        <Spin size="large"></Spin>
      </div>
      <div v-else class="detail">
        <div class="detail-head">
          <span class="detail-name">{{ detailName }}</span>
          <span class="detail-progress">总进度：{{ detailDoneCount }}/{{ detailTotalCount }}</span>
        </div>
        <Table :columns="detailColumns" :data="detailRows" border stripe size="small"></Table>
      </div>
    </Modal>
  </div>
</template>

<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  name: 'TchOnboardingList',
  data () {
    return {
      searchLoading: false,
        rankScoreSeq: 0,
      tableLoading: false,
      detailLoading: false,
      detailVisible: false,
      detailName: '',
      detailDoneCount: 0,
      detailTotalCount: 0,
      detailRows: [],
      tableData: [],
      queryParam: {
        tchId: '',
        keyword: ''
      },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
      },
      columns: [
        {
          title: '老师ID',
          key: 'tchId',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '姓名',
          minWidth: 180,
          align: 'center',
          fixed: 'left',
          render: (h, params) => {
            return renderTchNameWithScore(h, {
              text: this.tchName(params.row),
              score: params.row.monthRankScore
            })
          }
        },
        {
          title: '版本',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.versionId == null ? '-' : params.row.versionId)
          }
        },
        {
          title: '总进度',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', this.progressText(params.row.doneCount, params.row.totalCount))
          }
        },
        {
          title: '最后更新',
          minWidth: 160,
          key: 'lastUpdateTime'
        },
        {
          title: '操作',
          width: 90,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('Button', {
              props: {type: 'primary', size: 'small'},
              on: {click: () => this.openDetail(params.row)}
            }, '查看')
          }
        }
      ],
      detailColumns: [
        {
          title: '阶段',
          key: 'stageName',
          width: 180
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 200
        },
        {
          title: '是否完成',
          width: 90,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {color: params.row.done ? 'green' : 'default'}
            }, params.row.done ? '已完成' : '未完成')
          }
        },
        {
          title: '文字',
          minWidth: 160,
          render: (h, params) => {
            return h('span', params.row.textValue || '-')
          }
        },
        {
          title: '图片',
          width: 180,
          render: (h, params) => {
            return this.renderPhotos(h, params.row.photoUrls)
          }
        }
      ]
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    loadMonthRankScores () {
      const table = this.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

    tchName (row) {
      if (!row) {
        return ''
      }
      return ((row.firstName || '') + ' ' + (row.lastName || '')).trim()
    },
    progressText (done, total) {
      return (done || 0) + '/' + (total || 0)
    },
    search () {
      this.pagination.pageIndex = 1
      this.loadList()
    },
    loadList () {
      let self = this
      self.tableLoading = true
      self.searchLoading = true
      let params = {
        keyword: self.queryParam.keyword,
        page: self.pagination.pageIndex,
        pageSize: self.pagination.pageSize
      }
      if (self.queryParam.tchId) {
        params.tchId = self.queryParam.tchId
      }
      self.$http.get('/tchOnboarding/list', {params: params}).then(function (res) {
        let data = res.data || {}
        self.tableData = data.data || []
        self.loadMonthRankScores()
        self.pagination.totalCount = data.totalCount || 0
      }).catch(function () {
        self.tableData = []
        self.pagination.totalCount = 0
      }).then(function () {
        self.tableLoading = false
        self.searchLoading = false
      })
    },
    changePage (pageIndex) {
      this.pagination.pageIndex = pageIndex
      this.loadList()
    },
    changePageSize (pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageIndex = 1
      this.loadList()
    },
    openDetail (row) {
      let self = this
      self.detailVisible = true
      self.detailLoading = true
      self.detailName = self.tchName(row)
      self.detailRows = []
      self.detailDoneCount = 0
      self.detailTotalCount = 0
      self.$http.get('/tchOnboarding/detail', {params: {tchId: row.tchId}}).then(function (res) {
        let data = res.data || {}
        if (data.firstName || data.lastName) {
          self.detailName = ((data.firstName || '') + ' ' + (data.lastName || '')).trim()
        }
        let stages = data.stages || []
        self.detailRows = self.buildDetailRows(stages)
        let done = 0
        let total = 0
        stages.forEach(function (stage) {
          done += stage.doneCount || 0
          total += stage.totalCount || 0
        })
        self.detailDoneCount = done
        self.detailTotalCount = total
      }).catch(function () {
        self.detailRows = []
      }).then(function () {
        self.detailLoading = false
      })
    },
    buildDetailRows (stages) {
      let rows = []
      let list = stages || []
      list.forEach(function (stage) {
        let items = stage.items || []
        items.forEach(function (item) {
          rows.push({
            stageName: stage.name,
            title: item.title,
            done: item.done,
            textValue: item.textValue,
            photoUrls: item.photoUrls,
            finishTime: item.finishTime
          })
        })
      })
      return rows
    },
    parsePhotoUrls (photoUrls) {
      if (!photoUrls) {
        return []
      }
      if (Array.isArray(photoUrls)) {
        return photoUrls.map(function (url) {
          return (url || '').trim()
        }).filter(function (url) {
          return !!url
        })
      }
      return String(photoUrls).split(',').map(function (url) {
        return url.trim()
      }).filter(function (url) {
        return !!url
      })
    },
    renderPhotos (h, photoUrls) {
      let urls = this.parsePhotoUrls(photoUrls)
      if (!urls.length) {
        return h('span', '-')
      }
      let images = urls.map(url => {
        return h('img', {
          attrs: {src: url},
          style: {
            width: '48px',
            height: '48px',
            objectFit: 'cover',
            marginRight: '4px',
            borderRadius: '3px',
            cursor: 'pointer'
          },
          on: {click: () => window.open(url, '_blank')}
        })
      })
      return h('div', images)
    }
  }
}
</script>

<style scoped>
.list {
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.search {
  background: #f8f8f9;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.detail-head {
  margin-bottom: 12px;
}

.detail-name {
  font-size: 16px;
  font-weight: bold;
  margin-right: 16px;
}

.detail-progress {
  color: #2dadff;
}
</style>



// WEBPACK FOOTER //
// TchOnboardingList.vue?378b642a